// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Facility, IFacility } from "./Facility.gen";
import { Device, IDevice } from "./Device.gen";
import { ClientEndpoint, IClientEndpoint } from "./ClientEndpoints.ClientEndpoint.gen";
import { DetectionZone, IDetectionZone } from "./DetectionZone.gen";
import { ScreenLine, IScreenLine } from "./ScreenLine.gen";
import { EventTriggerDevice, IEventTriggerDevice } from "./EventTriggers.EventTriggerDevice.gen";
import { EventTriggerFacility, IEventTriggerFacility } from "./EventTriggers.EventTriggerFacility.gen";
import { EventTriggerClientEndpoint, IEventTriggerClientEndpoint } from "./EventTriggers.EventTriggerClientEndpoint.gen";
import { EventTriggerType } from "./Shared.Models.Api.V1.EventTriggers.EventTriggerType.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IScreenLineInboundEventTrigger {
	triggerType: EventTriggerType;

	facilities: IFacility[] | undefined;

	devices: IDevice[] | undefined;

	clientEndpoints: IClientEndpoint[] | undefined;

	detectionZone: IDetectionZone | undefined;

	screenLine: IScreenLine | undefined;

	eventTriggerDevices: IEventTriggerDevice[] | undefined;

	eventTriggerFacilities: IEventTriggerFacility[] | undefined;

	eventTriggerClientEndpoints: IEventTriggerClientEndpoint[] | undefined;

	description: string | undefined;

	clientEndpoint: IClientEndpoint | undefined;

	endpointConfig: string | undefined;

	clientEndpointId: string | undefined;

	id: string | undefined;

	organizationId: string | undefined;

	detectionZoneId: string | undefined;

	screenLineId: string | undefined;

	targetFilter: TargetTypes | number ;

	processOnDevice: boolean;

	minValue: number | undefined;

	maxValue: number | undefined;

	additionalValue: number | undefined;

	laneLineIds: string[] | undefined;

	isEnabled: boolean | undefined;

	captureVideo: boolean | undefined;

	capturePhoto: boolean | undefined;

	mediaRetentionDays: number | undefined;

	lastModifiedBy: string | undefined;

	lastModified: string | undefined;

	name: string | undefined;

	$type?: string | undefined;
}
export class ScreenLineInboundEventTrigger {
	constructor(data?: IScreenLineInboundEventTrigger) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.facilities = data.facilities ? data.facilities.map((f: any) => new Facility(f)) : [];
		this.devices = data.devices ? data.devices.map((d: any) => new Device(d)) : [];
		this.clientEndpoints = data.clientEndpoints ? data.clientEndpoints.map((c: any) => new ClientEndpoint(c)) : [];
		if (data.detectionZone) { this.detectionZone = new DetectionZone(data.detectionZone); }
		if (data.screenLine) { this.screenLine = new ScreenLine(data.screenLine); }
		this.eventTriggerDevices = data.eventTriggerDevices ? data.eventTriggerDevices.map((e: any) => new EventTriggerDevice(e)) : [];
		this.eventTriggerFacilities = data.eventTriggerFacilities ? data.eventTriggerFacilities.map((e: any) => new EventTriggerFacility(e)) : [];
		this.eventTriggerClientEndpoints = data.eventTriggerClientEndpoints ? data.eventTriggerClientEndpoints.map((e: any) => new EventTriggerClientEndpoint(e)) : [];
		if (data.clientEndpoint) { this.clientEndpoint = new ClientEndpoint(data.clientEndpoint); }
		if (data.lastModified) { this.lastModified = new Date(data.lastModified); }
	}

	@IsNotEmpty()
	triggerType: EventTriggerType = 0;

	facilities: Facility[] | undefined = [];

	devices: Device[] | undefined = [];

	clientEndpoints: ClientEndpoint[] | undefined = [];

	detectionZone: DetectionZone | undefined;

	screenLine: ScreenLine | undefined;

	eventTriggerDevices: EventTriggerDevice[] | undefined = [];

	eventTriggerFacilities: EventTriggerFacility[] | undefined = [];

	eventTriggerClientEndpoints: EventTriggerClientEndpoint[] | undefined = [];

	description: string | undefined;

	clientEndpoint: ClientEndpoint | undefined;

	endpointConfig: string | undefined;

	clientEndpointId: string | undefined;

	id: string | undefined;

	organizationId: string | undefined;

	detectionZoneId: string | undefined;

	screenLineId: string | undefined;

	targetFilter: TargetTypes | number  = 0;

	processOnDevice: boolean = false;

	minValue: number | undefined;

	maxValue: number | undefined;

	additionalValue: number | undefined;

	laneLineIds: string[] | undefined;

	isEnabled: boolean | undefined;

	captureVideo: boolean | undefined;

	capturePhoto: boolean | undefined;

	mediaRetentionDays: number | undefined;

	lastModifiedBy: string | undefined;

	lastModified: Date | undefined;

	name: string | undefined;

	static $type: string = "CoreApi.Models.EventTriggers.ScreenLineInboundEventTrigger, ";
	$type?: string | undefined = ScreenLineInboundEventTrigger.$type;
}

